import { render, staticRenderFns } from "./classlog.vue?vue&type=template&id=53ec89e6&"
import script from "./classlog.vue?vue&type=script&lang=js&"
export * from "./classlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports